import { combineReducers } from 'redux'
import * as actions from '../actions/actions'
import app from './app'
import otp from './otp'
import card from './card'
import {initialState} from '../state';

const session = (state = initialState, action) => {


    switch (action.type) {
        case actions.LOGOUT:
            return Object.assign({}, state, { app: { stage: action.stage } });
        default:
            return {
                app: app(state.app, action),
                otp: otp(state.otp, action),
                card: card(state.card, action)
            };
    }
}


const oscApp = combineReducers({ session });
export default oscApp



// WEBPACK FOOTER //
// ./src/reducers/session.js